var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendDisabled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.14346 10.1411L4.429 10.1411M19.5601 9.60606C19.6604 9.65489 19.7449 9.73095 19.804 9.82554C19.8631 9.92014 19.8944 10.0295 19.8943 10.141C19.8942 10.2525 19.8628 10.3618 19.8035 10.4563C19.7443 10.5508 19.6596 10.6268 19.5593 10.6755L1.60189 19.3234C1.49452 19.375 1.3741 19.3932 1.25625 19.3756C1.1384 19.358 1.02857 19.3054 0.940991 19.2246C0.853415 19.1438 0.79214 19.0385 0.765115 18.9225C0.738091 18.8064 0.746565 18.6849 0.789437 18.5738L3.95048 10.3541C4.00318 10.217 4.00318 10.0653 3.95048 9.92821L0.790221 1.70776C0.747726 1.59671 0.739507 1.47547 0.766624 1.35971C0.793741 1.24394 0.85495 1.13896 0.942341 1.05834C1.02973 0.977717 1.13929 0.925151 1.25687 0.907433C1.37444 0.889715 1.49462 0.90766 1.60189 0.958949L19.5601 9.60606Z",
    stroke: "#7C7C7C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendDisabled);
export default __webpack_public_path__ + "static/media/send-disabled.1ab5eba838938a126c16a196a28c41d0.svg";
export { ForwardRef as ReactComponent };